/* eslint-disable */
import { useState } from 'react';
import { useForm } from "react-hook-form";

let attribute_arr = [
    { "vals": "sales-status-Not Interested", "text": "Not Interested" },
    { "vals": "sales-status-Interested", "text": "Interested" },
    { "vals": "sales-status-Complete", "text": "Client" },
    { "vals": "sales-lead-Hot", "text": "Hot" },
    { "vals": "sales-lead-Warm", "text": "Warm" },
    { "vals": "sales-lead-Cold", "text": "Cold" },
]


export default function OnAtrribute({ event, setNodes, wa_authKey }) {
    const [refresher, setRefresher] = useState(false);
    const { register: att_reg, handleSubmit: att_handle, formState: { errors: att_err } } = useForm({
        defaultValues: { attri: event.data.value.api.attributeDetails }
    });

    const att_assign = (val) => {
        setNodes(nds => nds.map(node => {
            if (node.id === event.id) {
                node.data.value.api = { "attributeDetails": val, "auth_key": wa_authKey };
            }
            return node;
        }));
        setRefresher(!refresher);
    };
    return (
        <div className="card-body mt-0">
            <div className="contact_add_div">
                <div className="mx-auto">
                    <select {...att_reg("attri", { required: true, onChange: (e) => att_assign(e.target.value) })} className="form-control">
                        <option value="" disabled>Select Attribute</option>
                        {attribute_arr.map(x => <option key={x.vals} value={x.vals}>{x.text}</option>)}
                    </select>
                </div>
            </div>
        </div>
    )
}